export const getAccessToken = () => localStorage.getItem("token");

export const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userRole");
  localStorage.removeItem("userDesignation");
  localStorage.removeItem("userData");
  localStorage.removeItem("user");
};

export const getRestaurantName = () =>
  localStorage.getItem("selectedRestaurantName") ||
  localStorage.getItem("selectedRestaurantManagementName") ||
  "Restaurant";
